import { commonjsGlobal } from '../../_virtual/_commonjsHelpers.js';
import { u as underscoreMin } from '../../_virtual/underscore-min.js';

(function (module, exports) {
!function (n, r) {
  module.exports = r() ;
}(commonjsGlobal, function () {
  //     Underscore.js 1.13.8
  //     https://underscorejs.org
  //     (c) 2009-2026 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
  //     Underscore may be freely distributed under the MIT license.
  var n = "1.13.8",
      r = "object" == typeof self && self.self === self && self || "object" == typeof commonjsGlobal && commonjsGlobal.global === commonjsGlobal && commonjsGlobal || Function("return this")() || {},
      t = Array.prototype,
      e = Object.prototype,
      u = "undefined" != typeof Symbol ? Symbol.prototype : null,
      i = t.push,
      o = t.slice,
      a = e.toString,
      f = e.hasOwnProperty,
      c = "undefined" != typeof ArrayBuffer,
      l = "undefined" != typeof DataView,
      s = Array.isArray,
      p = Object.keys,
      v = Object.create,
      h = c && ArrayBuffer.isView,
      y = isNaN,
      d = isFinite,
      g = !{
    toString: null
  }.propertyIsEnumerable("toString"),
      b = ["valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"],
      m = Math.pow(2, 53) - 1;

  function j(n, r) {
    return r = null == r ? n.length - 1 : +r, function () {
      for (var t = Math.max(arguments.length - r, 0), e = Array(t), u = 0; u < t; u++) e[u] = arguments[u + r];

      switch (r) {
        case 0:
          return n.call(this, e);

        case 1:
          return n.call(this, arguments[0], e);

        case 2:
          return n.call(this, arguments[0], arguments[1], e);
      }

      var i = Array(r + 1);

      for (u = 0; u < r; u++) i[u] = arguments[u];

      return i[r] = e, n.apply(this, i);
    };
  }

  function w(n) {
    var r = typeof n;
    return "function" === r || "object" === r && !!n;
  }

  function _(n) {
    return void 0 === n;
  }

  function A(n) {
    return !0 === n || !1 === n || "[object Boolean]" === a.call(n);
  }

  function x(n) {
    var r = "[object " + n + "]";
    return function (n) {
      return a.call(n) === r;
    };
  }

  var S = x("String"),
      O = x("Number"),
      M = x("Date"),
      E = x("RegExp"),
      B = x("Error"),
      N = x("Symbol"),
      k = x("ArrayBuffer"),
      I = x("Function"),
      T = r.document && r.document.childNodes;
  "function" != typeof /./ && "object" != typeof Int8Array && "function" != typeof T && (I = function (n) {
    return "function" == typeof n || !1;
  });
  var D = I,
      R = x("Object"),
      V = l && (!/\[native code\]/.test(String(DataView)) || R(new DataView(new ArrayBuffer(8)))),
      F = "undefined" != typeof Map && R(new Map()),
      P = x("DataView");
  var q = V ? function (n) {
    return null != n && D(n.getInt8) && k(n.buffer);
  } : P,
      U = s || x("Array");

  function W(n, r) {
    return null != n && f.call(n, r);
  }

  var z = x("Arguments");
  !function () {
    z(arguments) || (z = function (n) {
      return W(n, "callee");
    });
  }();
  var L = z;

  function $(n) {
    return O(n) && y(n);
  }

  function C(n) {
    return function () {
      return n;
    };
  }

  function K(n) {
    return function (r) {
      var t = n(r);
      return "number" == typeof t && t >= 0 && t <= m;
    };
  }

  function J(n) {
    return function (r) {
      return null == r ? void 0 : r[n];
    };
  }

  var G = J("byteLength"),
      H = K(G),
      Q = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
  var X = c ? function (n) {
    return h ? h(n) && !q(n) : H(n) && Q.test(a.call(n));
  } : C(!1),
      Y = J("length");

  function Z(n, r) {
    r = function (n) {
      for (var r = {}, t = n.length, e = 0; e < t; ++e) r[n[e]] = !0;

      return {
        contains: function (n) {
          return !0 === r[n];
        },
        push: function (t) {
          return r[t] = !0, n.push(t);
        }
      };
    }(r);

    var t = b.length,
        u = n.constructor,
        i = D(u) && u.prototype || e,
        o = "constructor";

    for (W(n, o) && !r.contains(o) && r.push(o); t--;) (o = b[t]) in n && n[o] !== i[o] && !r.contains(o) && r.push(o);
  }

  function nn(n) {
    if (!w(n)) return [];
    if (p) return p(n);
    var r = [];

    for (var t in n) W(n, t) && r.push(t);

    return g && Z(n, r), r;
  }

  function rn(n, r) {
    var t = nn(r),
        e = t.length;
    if (null == n) return !e;

    for (var u = Object(n), i = 0; i < e; i++) {
      var o = t[i];
      if (r[o] !== u[o] || !(o in u)) return !1;
    }

    return !0;
  }

  function tn(n) {
    return n instanceof tn ? n : this instanceof tn ? void (this._wrapped = n) : new tn(n);
  }

  function en(n) {
    return new Uint8Array(n.buffer || n, n.byteOffset || 0, G(n));
  }

  tn.VERSION = n, tn.prototype.value = function () {
    return this._wrapped;
  }, tn.prototype.valueOf = tn.prototype.toJSON = tn.prototype.value, tn.prototype.toString = function () {
    return String(this._wrapped);
  };
  var un = "[object DataView]";

  function on(n) {
    if (!w(n)) return [];
    var r = [];

    for (var t in n) r.push(t);

    return g && Z(n, r), r;
  }

  function an(n) {
    var r = Y(n);
    return function (t) {
      if (null == t) return !1;
      var e = on(t);
      if (Y(e)) return !1;

      for (var u = 0; u < r; u++) if (!D(t[n[u]])) return !1;

      return n !== vn || !D(t[fn]);
    };
  }

  var fn = "forEach",
      cn = "has",
      ln = ["clear", "delete"],
      sn = ["get", cn, "set"],
      pn = ln.concat(fn, sn),
      vn = ln.concat(sn),
      hn = ["add"].concat(ln, fn, cn),
      yn = F ? an(pn) : x("Map"),
      dn = F ? an(vn) : x("WeakMap"),
      gn = F ? an(hn) : x("Set"),
      bn = x("WeakSet");

  function mn(n) {
    for (var r = nn(n), t = r.length, e = Array(t), u = 0; u < t; u++) e[u] = n[r[u]];

    return e;
  }

  function jn(n) {
    for (var r = {}, t = nn(n), e = 0, u = t.length; e < u; e++) r[n[t[e]]] = t[e];

    return r;
  }

  function wn(n) {
    var r = [];

    for (var t in n) D(n[t]) && r.push(t);

    return r.sort();
  }

  function _n(n, r) {
    return function (t) {
      var e = arguments.length;
      if (r && (t = Object(t)), e < 2 || null == t) return t;

      for (var u = 1; u < e; u++) for (var i = arguments[u], o = n(i), a = o.length, f = 0; f < a; f++) {
        var c = o[f];
        r && void 0 !== t[c] || (t[c] = i[c]);
      }

      return t;
    };
  }

  var An = _n(on),
      xn = _n(nn),
      Sn = _n(on, !0);

  function On(n) {
    if (!w(n)) return {};
    if (v) return v(n);

    var r = function () {};

    r.prototype = n;
    var t = new r();
    return r.prototype = null, t;
  }

  function Mn(n) {
    return U(n) ? n : [n];
  }

  function En(n) {
    return tn.toPath(n);
  }

  function Bn(n, r) {
    for (var t = r.length, e = 0; e < t; e++) {
      if (null == n) return;
      n = n[r[e]];
    }

    return t ? n : void 0;
  }

  function Nn(n, r, t) {
    var e = Bn(n, En(r));
    return _(e) ? t : e;
  }

  function kn(n) {
    return n;
  }

  function In(n) {
    return n = xn({}, n), function (r) {
      return rn(r, n);
    };
  }

  function Tn(n) {
    return n = En(n), function (r) {
      return Bn(r, n);
    };
  }

  function Dn(n, r, t) {
    if (void 0 === r) return n;

    switch (null == t ? 3 : t) {
      case 1:
        return function (t) {
          return n.call(r, t);
        };

      case 3:
        return function (t, e, u) {
          return n.call(r, t, e, u);
        };

      case 4:
        return function (t, e, u, i) {
          return n.call(r, t, e, u, i);
        };
    }

    return function () {
      return n.apply(r, arguments);
    };
  }

  function Rn(n, r, t) {
    return null == n ? kn : D(n) ? Dn(n, r, t) : w(n) && !U(n) ? In(n) : Tn(n);
  }

  function Vn(n, r) {
    return Rn(n, r, 1 / 0);
  }

  function Fn(n, r, t) {
    return tn.iteratee !== Vn ? tn.iteratee(n, r) : Rn(n, r, t);
  }

  function Pn() {}

  function qn(n, r) {
    return null == r && (r = n, n = 0), n + Math.floor(Math.random() * (r - n + 1));
  }

  tn.toPath = Mn, tn.iteratee = Vn;

  var Un = Date.now || function () {
    return new Date().getTime();
  };

  function Wn(n) {
    var r = function (r) {
      return n[r];
    },
        t = "(?:" + nn(n).join("|") + ")",
        e = RegExp(t),
        u = RegExp(t, "g");

    return function (n) {
      return n = null == n ? "" : "" + n, e.test(n) ? n.replace(u, r) : n;
    };
  }

  var zn = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#x27;",
    "`": "&#x60;"
  },
      Ln = Wn(zn),
      $n = Wn(jn(zn)),
      Cn = tn.templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  },
      Kn = /(.)^/,
      Jn = {
    "'": "'",
    "\\": "\\",
    "\r": "r",
    "\n": "n",
    "\u2028": "u2028",
    "\u2029": "u2029"
  },
      Gn = /\\|'|\r|\n|\u2028|\u2029/g;

  function Hn(n) {
    return "\\" + Jn[n];
  }

  var Qn = /^\s*(\w|\$)+\s*$/;
  var Xn = 0;

  function Yn(n, r, t, e, u) {
    if (!(e instanceof r)) return n.apply(t, u);
    var i = On(n.prototype),
        o = n.apply(i, u);
    return w(o) ? o : i;
  }

  var Zn = j(function (n, r) {
    var t = Zn.placeholder,
        e = function () {
      for (var u = 0, i = r.length, o = Array(i), a = 0; a < i; a++) o[a] = r[a] === t ? arguments[u++] : r[a];

      for (; u < arguments.length;) o.push(arguments[u++]);

      return Yn(n, e, this, this, o);
    };

    return e;
  });
  Zn.placeholder = tn;
  var nr = j(function (n, r, t) {
    if (!D(n)) throw new TypeError("Bind must be called on a function");
    var e = j(function (u) {
      return Yn(n, e, r, this, t.concat(u));
    });
    return e;
  }),
      rr = K(Y);

  function tr(n, r, t) {
    r || 0 === r || (r = 1 / 0);

    for (var e = [], u = 0, i = 0, o = Y(n) || 0, a = []; 1;) if (i >= o) {
      if (!a.length) break;
      var f = a.pop();
      i = f.i, n = f.v, o = Y(n);
    } else {
      var c = n[i++];
      a.length >= r ? e[u++] = c : rr(c) && (U(c) || L(c)) ? (a.push({
        i: i,
        v: n
      }), i = 0, o = Y(n = c)) : t || (e[u++] = c);
    }

    return e;
  }

  var er = j(function (n, r) {
    var t = (r = tr(r, !1, !1)).length;
    if (t < 1) throw new Error("bindAll must be passed function names");

    for (; t--;) {
      var e = r[t];
      n[e] = nr(n[e], n);
    }

    return n;
  });
  var ur = j(function (n, r, t) {
    return setTimeout(function () {
      return n.apply(null, t);
    }, r);
  }),
      ir = Zn(ur, tn, 1);

  function or(n) {
    return function () {
      return !n.apply(this, arguments);
    };
  }

  function ar(n, r) {
    var t;
    return function () {
      return --n > 0 && (t = r.apply(this, arguments)), n <= 1 && (r = null), t;
    };
  }

  var fr = Zn(ar, 2);

  function cr(n, r, t) {
    r = Fn(r, t);

    for (var e, u = nn(n), i = 0, o = u.length; i < o; i++) if (r(n[e = u[i]], e, n)) return e;
  }

  function lr(n) {
    return function (r, t, e) {
      t = Fn(t, e);

      for (var u = Y(r), i = n > 0 ? 0 : u - 1; i >= 0 && i < u; i += n) if (t(r[i], i, r)) return i;

      return -1;
    };
  }

  var sr = lr(1),
      pr = lr(-1);

  function vr(n, r, t, e) {
    for (var u = (t = Fn(t, e, 1))(r), i = 0, o = Y(n); i < o;) {
      var a = Math.floor((i + o) / 2);
      t(n[a]) < u ? i = a + 1 : o = a;
    }

    return i;
  }

  function hr(n, r, t) {
    return function (e, u, i) {
      var a = 0,
          f = Y(e);
      if ("number" == typeof i) n > 0 ? a = i >= 0 ? i : Math.max(i + f, a) : f = i >= 0 ? Math.min(i + 1, f) : i + f + 1;else if (t && i && f) return e[i = t(e, u)] === u ? i : -1;
      if (u != u) return (i = r(o.call(e, a, f), $)) >= 0 ? i + a : -1;

      for (i = n > 0 ? a : f - 1; i >= 0 && i < f; i += n) if (e[i] === u) return i;

      return -1;
    };
  }

  var yr = hr(1, sr, vr),
      dr = hr(-1, pr);

  function gr(n, r, t) {
    var e = (rr(n) ? sr : cr)(n, r, t);
    if (void 0 !== e && -1 !== e) return n[e];
  }

  function br(n, r, t) {
    var e, u;
    if (r = Dn(r, t), rr(n)) for (e = 0, u = n.length; e < u; e++) r(n[e], e, n);else {
      var i = nn(n);

      for (e = 0, u = i.length; e < u; e++) r(n[i[e]], i[e], n);
    }
    return n;
  }

  function mr(n, r, t) {
    r = Fn(r, t);

    for (var e = !rr(n) && nn(n), u = (e || n).length, i = Array(u), o = 0; o < u; o++) {
      var a = e ? e[o] : o;
      i[o] = r(n[a], a, n);
    }

    return i;
  }

  function jr(n) {
    var r = function (r, t, e, u) {
      var i = !rr(r) && nn(r),
          o = (i || r).length,
          a = n > 0 ? 0 : o - 1;

      for (u || (e = r[i ? i[a] : a], a += n); a >= 0 && a < o; a += n) {
        var f = i ? i[a] : a;
        e = t(e, r[f], f, r);
      }

      return e;
    };

    return function (n, t, e, u) {
      var i = arguments.length >= 3;
      return r(n, Dn(t, u, 4), e, i);
    };
  }

  var wr = jr(1),
      _r = jr(-1);

  function Ar(n, r, t) {
    var e = [];
    return r = Fn(r, t), br(n, function (n, t, u) {
      r(n, t, u) && e.push(n);
    }), e;
  }

  function xr(n, r, t) {
    r = Fn(r, t);

    for (var e = !rr(n) && nn(n), u = (e || n).length, i = 0; i < u; i++) {
      var o = e ? e[i] : i;
      if (!r(n[o], o, n)) return !1;
    }

    return !0;
  }

  function Sr(n, r, t) {
    r = Fn(r, t);

    for (var e = !rr(n) && nn(n), u = (e || n).length, i = 0; i < u; i++) {
      var o = e ? e[i] : i;
      if (r(n[o], o, n)) return !0;
    }

    return !1;
  }

  function Or(n, r, t, e) {
    return rr(n) || (n = mn(n)), ("number" != typeof t || e) && (t = 0), yr(n, r, t) >= 0;
  }

  var Mr = j(function (n, r, t) {
    var e, u;
    return D(r) ? u = r : (r = En(r), e = r.slice(0, -1), r = r[r.length - 1]), mr(n, function (n) {
      var i = u;

      if (!i) {
        if (e && e.length && (n = Bn(n, e)), null == n) return;
        i = n[r];
      }

      return null == i ? i : i.apply(n, t);
    });
  });

  function Er(n, r) {
    return mr(n, Tn(r));
  }

  function Br(n, r, t) {
    var e,
        u,
        i = -1 / 0,
        o = -1 / 0;
    if (null == r || "number" == typeof r && "object" != typeof n[0] && null != n) for (var a = 0, f = (n = rr(n) ? n : mn(n)).length; a < f; a++) null != (e = n[a]) && e > i && (i = e);else r = Fn(r, t), br(n, function (n, t, e) {
      ((u = r(n, t, e)) > o || u === -1 / 0 && i === -1 / 0) && (i = n, o = u);
    });
    return i;
  }

  var Nr = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;

  function kr(n) {
    return n ? U(n) ? o.call(n) : S(n) ? n.match(Nr) : rr(n) ? mr(n, kn) : mn(n) : [];
  }

  function Ir(n, r, t) {
    if (null == r || t) return rr(n) || (n = mn(n)), n[qn(n.length - 1)];
    var e = kr(n),
        u = Y(e);
    r = Math.max(Math.min(r, u), 0);

    for (var i = u - 1, o = 0; o < r; o++) {
      var a = qn(o, i),
          f = e[o];
      e[o] = e[a], e[a] = f;
    }

    return e.slice(0, r);
  }

  function Tr(n, r) {
    return function (t, e, u) {
      var i = r ? [[], []] : {};
      return e = Fn(e, u), br(t, function (r, u) {
        var o = e(r, u, t);
        n(i, r, o);
      }), i;
    };
  }

  var Dr = Tr(function (n, r, t) {
    W(n, t) ? n[t].push(r) : n[t] = [r];
  }),
      Rr = Tr(function (n, r, t) {
    n[t] = r;
  }),
      Vr = Tr(function (n, r, t) {
    W(n, t) ? n[t]++ : n[t] = 1;
  }),
      Fr = Tr(function (n, r, t) {
    n[t ? 0 : 1].push(r);
  }, !0);

  function Pr(n, r, t) {
    return r in t;
  }

  var qr = j(function (n, r) {
    var t = {},
        e = r[0];
    if (null == n) return t;
    D(e) ? (r.length > 1 && (e = Dn(e, r[1])), r = on(n)) : (e = Pr, r = tr(r, !1, !1), n = Object(n));

    for (var u = 0, i = r.length; u < i; u++) {
      var o = r[u],
          a = n[o];
      e(a, o, n) && (t[o] = a);
    }

    return t;
  }),
      Ur = j(function (n, r) {
    var t,
        e = r[0];
    return D(e) ? (e = or(e), r.length > 1 && (t = r[1])) : (r = mr(tr(r, !1, !1), String), e = function (n, t) {
      return !Or(r, t);
    }), qr(n, e, t);
  });

  function Wr(n, r, t) {
    return o.call(n, 0, Math.max(0, n.length - (null == r || t ? 1 : r)));
  }

  function zr(n, r, t) {
    return null == n || n.length < 1 ? null == r || t ? void 0 : [] : null == r || t ? n[0] : Wr(n, n.length - r);
  }

  function Lr(n, r, t) {
    return o.call(n, null == r || t ? 1 : r);
  }

  var $r = j(function (n, r) {
    return r = tr(r, !0, !0), Ar(n, function (n) {
      return !Or(r, n);
    });
  }),
      Cr = j(function (n, r) {
    return $r(n, r);
  });

  function Kr(n, r, t, e) {
    A(r) || (e = t, t = r, r = !1), null != t && (t = Fn(t, e));

    for (var u = [], i = [], o = 0, a = Y(n); o < a; o++) {
      var f = n[o],
          c = t ? t(f, o, n) : f;
      r && !t ? (o && i === c || u.push(f), i = c) : t ? Or(i, c) || (i.push(c), u.push(f)) : Or(u, f) || u.push(f);
    }

    return u;
  }

  var Jr = j(function (n) {
    return Kr(tr(n, !0, !0));
  });

  function Gr(n) {
    for (var r = n && Br(n, Y).length || 0, t = Array(r), e = 0; e < r; e++) t[e] = Er(n, e);

    return t;
  }

  var Hr = j(Gr);

  function Qr(n, r) {
    return n._chain ? tn(r).chain() : r;
  }

  function Xr(n) {
    return br(wn(n), function (r) {
      var t = tn[r] = n[r];

      tn.prototype[r] = function () {
        var n = [this._wrapped];
        return i.apply(n, arguments), Qr(this, t.apply(tn, n));
      };
    }), tn;
  }

  br(["pop", "push", "reverse", "shift", "sort", "splice", "unshift"], function (n) {
    var r = t[n];

    tn.prototype[n] = function () {
      var t = this._wrapped;
      return null != t && (r.apply(t, arguments), "shift" !== n && "splice" !== n || 0 !== t.length || delete t[0]), Qr(this, t);
    };
  }), br(["concat", "join", "slice"], function (n) {
    var r = t[n];

    tn.prototype[n] = function () {
      var n = this._wrapped;
      return null != n && (n = r.apply(n, arguments)), Qr(this, n);
    };
  });
  var Yr = Xr({
    __proto__: null,
    VERSION: n,
    restArguments: j,
    isObject: w,
    isNull: function (n) {
      return null === n;
    },
    isUndefined: _,
    isBoolean: A,
    isElement: function (n) {
      return !(!n || 1 !== n.nodeType);
    },
    isString: S,
    isNumber: O,
    isDate: M,
    isRegExp: E,
    isError: B,
    isSymbol: N,
    isArrayBuffer: k,
    isDataView: q,
    isArray: U,
    isFunction: D,
    isArguments: L,
    isFinite: function (n) {
      return !N(n) && d(n) && !isNaN(parseFloat(n));
    },
    isNaN: $,
    isTypedArray: X,
    isEmpty: function (n) {
      if (null == n) return !0;
      var r = Y(n);
      return "number" == typeof r && (U(n) || S(n) || L(n)) ? 0 === r : 0 === Y(nn(n));
    },
    isMatch: rn,
    isEqual: function (n, r) {
      for (var t = [{
        a: n,
        b: r
      }], e = [], i = []; t.length;) {
        var o = t.pop();

        if (!0 !== o) {
          if ((n = o.a) === (r = o.b)) {
            if (0 !== n || 1 / n == 1 / r) continue;
            return !1;
          }

          if (null == n || null == r) return !1;

          if (n != n) {
            if (r != r) continue;
            return !1;
          }

          var f = typeof n;
          if ("function" !== f && "object" !== f && "object" != typeof r) return !1;
          n instanceof tn && (n = n._wrapped), r instanceof tn && (r = r._wrapped);
          var c = a.call(n);
          if (c !== a.call(r)) return !1;

          if (V && "[object Object]" == c && q(n)) {
            if (!q(r)) return !1;
            c = un;
          }

          switch (c) {
            case "[object RegExp]":
            case "[object String]":
              if ("" + n == "" + r) continue;
              return !1;

            case "[object Number]":
              t.push({
                a: +n,
                b: +r
              });
              continue;

            case "[object Date]":
            case "[object Boolean]":
              if (+n == +r) continue;
              return !1;

            case "[object Symbol]":
              if (u.valueOf.call(n) === u.valueOf.call(r)) continue;
              return !1;

            case "[object ArrayBuffer]":
            case un:
              t.push({
                a: en(n),
                b: en(r)
              });
              continue;
          }

          var l = "[object Array]" === c;

          if (!l && X(n)) {
            if (G(n) !== G(r)) return !1;
            if (n.buffer === r.buffer && n.byteOffset === r.byteOffset) continue;
            l = !0;
          }

          if (!l) {
            if ("object" != typeof n || "object" != typeof r) return !1;
            var s = n.constructor,
                p = r.constructor;
            if (s !== p && !(D(s) && s instanceof s && D(p) && p instanceof p) && "constructor" in n && "constructor" in r) return !1;
          }

          for (var v = e.length; v--;) if (e[v] === n) {
            if (i[v] === r) break;
            return !1;
          }

          if (!(v >= 0)) if (e.push(n), i.push(r), t.push(!0), l) {
            if ((v = n.length) !== r.length) return !1;

            for (; v--;) t.push({
              a: n[v],
              b: r[v]
            });
          } else {
            var h,
                y = nn(n);
            if (v = y.length, nn(r).length !== v) return !1;

            for (; v--;) {
              if (!W(r, h = y[v])) return !1;
              t.push({
                a: n[h],
                b: r[h]
              });
            }
          }
        } else e.pop(), i.pop();
      }

      return !0;
    },
    isMap: yn,
    isWeakMap: dn,
    isSet: gn,
    isWeakSet: bn,
    keys: nn,
    allKeys: on,
    values: mn,
    pairs: function (n) {
      for (var r = nn(n), t = r.length, e = Array(t), u = 0; u < t; u++) e[u] = [r[u], n[r[u]]];

      return e;
    },
    invert: jn,
    functions: wn,
    methods: wn,
    extend: An,
    extendOwn: xn,
    assign: xn,
    defaults: Sn,
    create: function (n, r) {
      var t = On(n);
      return r && xn(t, r), t;
    },
    clone: function (n) {
      return w(n) ? U(n) ? n.slice() : An({}, n) : n;
    },
    tap: function (n, r) {
      return r(n), n;
    },
    get: Nn,
    has: function (n, r) {
      for (var t = (r = En(r)).length, e = 0; e < t; e++) {
        var u = r[e];
        if (!W(n, u)) return !1;
        n = n[u];
      }

      return !!t;
    },
    mapObject: function (n, r, t) {
      r = Fn(r, t);

      for (var e = nn(n), u = e.length, i = {}, o = 0; o < u; o++) {
        var a = e[o];
        i[a] = r(n[a], a, n);
      }

      return i;
    },
    identity: kn,
    constant: C,
    noop: Pn,
    toPath: Mn,
    property: Tn,
    propertyOf: function (n) {
      return null == n ? Pn : function (r) {
        return Nn(n, r);
      };
    },
    matcher: In,
    matches: In,
    times: function (n, r, t) {
      var e = Array(Math.max(0, n));
      r = Dn(r, t, 1);

      for (var u = 0; u < n; u++) e[u] = r(u);

      return e;
    },
    random: qn,
    now: Un,
    escape: Ln,
    unescape: $n,
    templateSettings: Cn,
    template: function (n, r, t) {
      !r && t && (r = t), r = Sn({}, r, tn.templateSettings);
      var e = RegExp([(r.escape || Kn).source, (r.interpolate || Kn).source, (r.evaluate || Kn).source].join("|") + "|$", "g"),
          u = 0,
          i = "__p+='";
      n.replace(e, function (r, t, e, o, a) {
        return i += n.slice(u, a).replace(Gn, Hn), u = a + r.length, t ? i += "'+\n((__t=(" + t + "))==null?'':_.escape(__t))+\n'" : e ? i += "'+\n((__t=(" + e + "))==null?'':__t)+\n'" : o && (i += "';\n" + o + "\n__p+='"), r;
      }), i += "';\n";
      var o,
          a = r.variable;

      if (a) {
        if (!Qn.test(a)) throw new Error("variable is not a bare identifier: " + a);
      } else i = "with(obj||{}){\n" + i + "}\n", a = "obj";

      i = "var __t,__p='',__j=Array.prototype.join," + "print=function(){__p+=__j.call(arguments,'');};\n" + i + "return __p;\n";

      try {
        o = new Function(a, "_", i);
      } catch (n) {
        throw n.source = i, n;
      }

      var f = function (n) {
        return o.call(this, n, tn);
      };

      return f.source = "function(" + a + "){\n" + i + "}", f;
    },
    result: function (n, r, t) {
      var e = (r = En(r)).length;
      if (!e) return D(t) ? t.call(n) : t;

      for (var u = 0; u < e; u++) {
        var i = null == n ? void 0 : n[r[u]];
        void 0 === i && (i = t, u = e), n = D(i) ? i.call(n) : i;
      }

      return n;
    },
    uniqueId: function (n) {
      var r = ++Xn + "";
      return n ? n + r : r;
    },
    chain: function (n) {
      var r = tn(n);
      return r._chain = !0, r;
    },
    iteratee: Vn,
    partial: Zn,
    bind: nr,
    bindAll: er,
    memoize: function (n, r) {
      var t = function (e) {
        var u = t.cache,
            i = "" + (r ? r.apply(this, arguments) : e);
        return W(u, i) || (u[i] = n.apply(this, arguments)), u[i];
      };

      return t.cache = {}, t;
    },
    delay: ur,
    defer: ir,
    throttle: function (n, r, t) {
      var e,
          u,
          i,
          o,
          a = 0;
      t || (t = {});

      var f = function () {
        a = !1 === t.leading ? 0 : Un(), e = null, o = n.apply(u, i), e || (u = i = null);
      },
          c = function () {
        var c = Un();
        a || !1 !== t.leading || (a = c);
        var l = r - (c - a);
        return u = this, i = arguments, l <= 0 || l > r ? (e && (clearTimeout(e), e = null), a = c, o = n.apply(u, i), e || (u = i = null)) : e || !1 === t.trailing || (e = setTimeout(f, l)), o;
      };

      return c.cancel = function () {
        clearTimeout(e), a = 0, e = u = i = null;
      }, c;
    },
    debounce: function (n, r, t) {
      var e,
          u,
          i,
          o,
          a,
          f = function () {
        var c = Un() - u;
        r > c ? e = setTimeout(f, r - c) : (e = null, t || (o = n.apply(a, i)), e || (i = a = null));
      },
          c = j(function (c) {
        return a = this, i = c, u = Un(), e || (e = setTimeout(f, r), t && (o = n.apply(a, i))), o;
      });

      return c.cancel = function () {
        clearTimeout(e), e = i = a = null;
      }, c;
    },
    wrap: function (n, r) {
      return Zn(r, n);
    },
    negate: or,
    compose: function () {
      var n = arguments,
          r = n.length - 1;
      return function () {
        for (var t = r, e = n[r].apply(this, arguments); t--;) e = n[t].call(this, e);

        return e;
      };
    },
    after: function (n, r) {
      return function () {
        if (--n < 1) return r.apply(this, arguments);
      };
    },
    before: ar,
    once: fr,
    findKey: cr,
    findIndex: sr,
    findLastIndex: pr,
    sortedIndex: vr,
    indexOf: yr,
    lastIndexOf: dr,
    find: gr,
    detect: gr,
    findWhere: function (n, r) {
      return gr(n, In(r));
    },
    each: br,
    forEach: br,
    map: mr,
    collect: mr,
    reduce: wr,
    foldl: wr,
    inject: wr,
    reduceRight: _r,
    foldr: _r,
    filter: Ar,
    select: Ar,
    reject: function (n, r, t) {
      return Ar(n, or(Fn(r)), t);
    },
    every: xr,
    all: xr,
    some: Sr,
    any: Sr,
    contains: Or,
    includes: Or,
    include: Or,
    invoke: Mr,
    pluck: Er,
    where: function (n, r) {
      return Ar(n, In(r));
    },
    max: Br,
    min: function (n, r, t) {
      var e,
          u,
          i = 1 / 0,
          o = 1 / 0;
      if (null == r || "number" == typeof r && "object" != typeof n[0] && null != n) for (var a = 0, f = (n = rr(n) ? n : mn(n)).length; a < f; a++) null != (e = n[a]) && e < i && (i = e);else r = Fn(r, t), br(n, function (n, t, e) {
        ((u = r(n, t, e)) < o || u === 1 / 0 && i === 1 / 0) && (i = n, o = u);
      });
      return i;
    },
    shuffle: function (n) {
      return Ir(n, 1 / 0);
    },
    sample: Ir,
    sortBy: function (n, r, t) {
      var e = 0;
      return r = Fn(r, t), Er(mr(n, function (n, t, u) {
        return {
          value: n,
          index: e++,
          criteria: r(n, t, u)
        };
      }).sort(function (n, r) {
        var t = n.criteria,
            e = r.criteria;

        if (t !== e) {
          if (t > e || void 0 === t) return 1;
          if (t < e || void 0 === e) return -1;
        }

        return n.index - r.index;
      }), "value");
    },
    groupBy: Dr,
    indexBy: Rr,
    countBy: Vr,
    partition: Fr,
    toArray: kr,
    size: function (n) {
      return null == n ? 0 : rr(n) ? n.length : nn(n).length;
    },
    pick: qr,
    omit: Ur,
    first: zr,
    head: zr,
    take: zr,
    initial: Wr,
    last: function (n, r, t) {
      return null == n || n.length < 1 ? null == r || t ? void 0 : [] : null == r || t ? n[n.length - 1] : Lr(n, Math.max(0, n.length - r));
    },
    rest: Lr,
    tail: Lr,
    drop: Lr,
    compact: function (n) {
      return Ar(n, Boolean);
    },
    flatten: function (n, r) {
      return tr(n, r, !1);
    },
    without: Cr,
    uniq: Kr,
    unique: Kr,
    union: Jr,
    intersection: function (n) {
      for (var r = [], t = arguments.length, e = 0, u = Y(n); e < u; e++) {
        var i = n[e];

        if (!Or(r, i)) {
          var o;

          for (o = 1; o < t && Or(arguments[o], i); o++);

          o === t && r.push(i);
        }
      }

      return r;
    },
    difference: $r,
    unzip: Gr,
    transpose: Gr,
    zip: Hr,
    object: function (n, r) {
      for (var t = {}, e = 0, u = Y(n); e < u; e++) r ? t[n[e]] = r[e] : t[n[e][0]] = n[e][1];

      return t;
    },
    range: function (n, r, t) {
      null == r && (r = n || 0, n = 0), t || (t = r < n ? -1 : 1);

      for (var e = Math.max(Math.ceil((r - n) / t), 0), u = Array(e), i = 0; i < e; i++, n += t) u[i] = n;

      return u;
    },
    chunk: function (n, r) {
      if (null == r || r < 1) return [];

      for (var t = [], e = 0, u = n.length; e < u;) t.push(o.call(n, e, e += r));

      return t;
    },
    mixin: Xr,
    default: tn
  });
  return Yr._ = Yr, Yr;
});
}(underscoreMin));

var _ = underscoreMin.exports;

export { _ as default };
